export default [
  {
    path: "/search",
    name: "search",
    component: (resolve) => require(["@/views/PCView/search/index.vue"], resolve),
    // redirect: "/paper",
    // children: [
    //   {
    //     path: "/paper",
    //     name: "paper",
    //     component: (resolve) =>
    //       require(["@/views/PCView/search/view/Paper.vue"], resolve),
    //   },
    //   {
    //     path: "/info",
    //     name: "info",
    //     component: (resolve) =>
    //       require(["@/views/PCView/search/view/Info.vue"], resolve),
    //   },
    //   {
    //     path: "/report",
    //     name: "report",
    //     component: (resolve) =>
    //       require(["@/views/PCView/search/view/Report.vue"], resolve),
    //   },
    //   {
    //     path: "/abstract",
    //     name: "abstract",
    //     component: (resolve) =>
    //       require(["@/views/PCView/search/view/Abstract.vue"], resolve),
    //   },
    //   {
    //     path: "/monograph",
    //     name: "monograph",
    //     component: (resolve) =>
    //       require(["@/views/PCView/search/view/Monograph.vue"], resolve),
    //   },
    //   {
    //     path: "/searchvideo",
    //     name: "searchvideo",
    //     component: (resolve) =>
    //       require(["@/views/PCView/search/view/SearchVideo.vue"], resolve),
    //   },
    //   {
    //     path: "/searchsub",
    //     name: "searchsub",
    //     component: (resolve) =>
    //       require(["@/views/PCView/search/view/SearchSub.vue"], resolve),
    //   },
    //   {
    //     path: "/organ",
    //     name: "organ",
    //     component: (resolve) =>
    //       require(["@/views/PCView/search/view/Organ.vue"], resolve),
    //   },
    // ],
  },
];
